module.exports = __webpack_public_path__ + "static/media/food_chain_twitter_image.7b2fc8fb.jpg";